<template>
          <b-card no-body>
            <!-- Card image -->
            <img class="card-img-top" src="img/custom/promotion_tips.png" alt="Image placeholder">
            <!-- Card body -->
            <b-card-body>
              <div class="loader" v-if="loading"></div>
              <b-card-title class="h2 mb-0">Promotion Tips </b-card-title>
              <small class="text-muted">by {{ document.account }} {{ formatDate(document.created_at) }} </small>
              <b-card-text class="mt-4">
                Bundled snap knowlede in a pdf. Don't miss ouit the chance to the hottest promotion tips and guides here. 
              </b-card-text>
              <a href="#!" @click="retrieveDocumentFile()" class="btn btn-sm btn-dark">download</a>
            </b-card-body>
          </b-card>
  
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from 'moment'
  
  export default {
    name: "promotion-tips",
    data() {
    return {
      loading: false,
      document: [],
      file: [],
    };
  },
    methods: {
      retrieveDocument() {
        this.loading = true;
        this.$api.getDocument("promotion_tips")
          .then((response) => {
            this.document = response.data;
          })
          .catch((e) => {
            console.log(e);
          }).finally(() => {
            this.loading = false
          });
      },
      retrieveDocumentFile() {
        this.loading = true;
        this.$api.getDocumentFile("promotion_tips")
          .then((response) => {
            console.log(response);
            this.forceFileDownload(response, this.document.filename);
          })
          .catch((e) => {
            console.log(e);
          }).finally(() => {
            this.loading = false
          });
      },
      forceFileDownload(response, title) {
        console.log(title)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', title)
        document.body.appendChild(link)
        link.click()
      },
      formatDate(date) {
        return moment(date).format("Do MMM YYYY")
      },
    },
    computed: {
      ...mapGetters({ currentAccount: 'currentAccount' }),
      commentsLoaded: function(){
          return this.commentsList ? true : false;
      }
    },
    mounted() {
      this.retrieveDocument();
    },
  };
  </script>
  <style>
  </style>